import { ContainerCard } from "../../../components/cards/containerCard";
import { LoanInvitationCard } from "../../../components/cards/invitationCardLoan";
import { InvitationCardLoader } from "../../../components/loaders/invitationCardLoader";
import { EmptyState } from "../../../components/states/emptyState";
import { PageTitle } from "../../../components/typography/pageTitle";
import { useFetchGuarantorLoanRequestsQuery } from "../../../redux/features/loans/loans.api";

export const LoanGuarantorInvitation = () => {
  const {
    data: guarantorRequests,
    isLoading: fetchingRequests,
    refetch,
  } = useFetchGuarantorLoanRequestsQuery(
    { detail: true },
    {
      refetchOnMountOrArgChange: true,
    }
  );

  return (
    <div className="w-full">
      <PageTitle
        text="Guarantee a loan"
        subtext="Kindly look through before consenting to be a guarantor to any of the loans listed here"
        containerClassName="max-md:hidden"
      />

      <div className="md:mt-6">
        {fetchingRequests ? (
          <InvitationCardLoader count={5} />
        ) : (
          <div className="flex flex-col gap-4">
            {!guarantorRequests?.data?.length && (
              <ContainerCard className=" !py-14">
                <EmptyState
                  image={
                    <img
                      src={"/assets/images/empty_state_invite.svg"}
                      alt="empty_state"
                    />
                  }
                  title="You have no invitations"
                  subtitle="All your invitations will be displayed here whenever you have any."
                />
              </ContainerCard>
            )}

            {(guarantorRequests?.data?.length ?? 0) > 0 &&
              guarantorRequests?.data?.map((invitation, idx) => {
                const key = `invitation-${idx}`;
                return (
                  <LoanInvitationCard
                    key={key}
                    invitation={invitation}
                    successCallback={() => {
                      refetch();
                    }}
                  />
                );
              })}
          </div>
        )}
      </div>
    </div>
  );
};
